export class MembershipPathSegments {
  static application(): string {
    return `application`;
  }
}
